import { FC } from "react";
import { Flex, Heading } from "@chakra-ui/react";
import { ReferAFriendHeading } from "~/features/Referral/ReferAFriendHeading";
import { Trans } from "~/utils/i18next";

export const RAFHeading: FC = () => {
  return (
    <Flex align="center" direction="column" gap={4} textAlign="center">
      <ReferAFriendHeading color="black" />
      <Heading variant="th-h3">
        <Trans i18nKey="inviteAFriend.invitee.welcome.title" />
      </Heading>
    </Flex>
  );
};
